<template>
    <div class="spin-wheel__arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="43" viewBox="0 0 38 43" fill="none">
            <g filter="url(#filter0_d_8463_2673)">
                <path
                    d="M23.4994 30.4336C21.6775 34.1929 16.3223 34.1929 14.5004 30.4336L3.59038 7.92139C1.98115 4.60086 4.39991 0.740819 8.08983 0.740819L29.91 0.740821C33.5999 0.740821 36.0186 4.60085 34.4094 7.92138L23.4994 30.4336Z"
                    fill="#FDAB00" />
                <path
                    d="M22.5995 29.9975C21.142 33.0049 16.8578 33.0049 15.4003 29.9975L4.49027 7.48528C3.20289 4.82885 5.13789 1.74082 8.08983 1.74082L29.91 1.74082C32.8619 1.74082 34.7969 4.82885 33.5095 7.48527L22.5995 29.9975Z"
                    stroke="#F8901F" stroke-width="2" />
            </g>
            <defs>
                <filter id="filter0_d_8463_2673" x="0.0834961" y="0.740822" width="37.8325" height="41.5122"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset dy="6" />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8463_2673" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8463_2673" result="shape" />
                </filter>
            </defs>
        </svg>
    </div>
</template>